import {Component, OnInit, AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {Subject, takeUntil} from 'rxjs';
import {AdminService} from '../services/admin.service';
import {AuthenticationService} from '../../auth/services/authentication.service';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';
import {User} from "../../auth/models/User";
import {News, Pagination} from "../../shared/SharedEntities";

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit, AfterViewInit, OnDestroy {
  news = new MatTableDataSource<News>();
  currentUser!: User;
  displayedColumns: string[] = ['title', 'status', 'open', 'remove'];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  totalItems = 0;
  pageSize = 10;
  private destroy$ = new Subject<void>();
  filterTitle: string = '';

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addNews() {
    this.router.navigate(['/admin-panel/admin-create-news']);
  }

  loadData(page: number = 0, pageSize: number = this.pageSize, query?: string) {
    if (this.currentUser) {
      this.adminService.getAllNews(page, pageSize, query).subscribe((result: Pagination<News>) => {
        this.news = new MatTableDataSource(result.content);
        this.totalItems = result.totalElements;
        this.paginator.length = this.totalItems;
        this.paginator.pageIndex = result.pageable.pageNumber;
      }, (error: any) => {
        console.error(error);
      });
    }
  }

  onPageChange(event: any) {
    this.loadData(event.pageIndex, event.pageSize, this.filterTitle);
  }

  deleteNews(newsId: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted',
      'The news has been deleted.',
      'Error',
      'An error occurred while deleting the news.',
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!'],
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteNews(newsId).subscribe(() => {
            Swal.fire(translations['Deleted'], translations['The news has been deleted.'], 'success');
            this.loadData(0, 10);
          }, (error) => {
            Swal.fire(translations['Error'], translations['An error occurred while deleting the news.'], 'error');
          });
        }
      });
    });
  }

  applyFilter() {
    this.loadData(0, this.pageSize, this.filterTitle);
  }

  clearFilter() {
    this.filterTitle = '';
    this.loadData(0, this.pageSize, "");
  }

}
